(function () {
  var polarizedMap = {};
  var mapEl = document.querySelector('script[data-polarized-map]');
  if (mapEl) {
    try { polarizedMap = JSON.parse(mapEl.textContent); } catch (e) { polarizedMap = {}; }
  }

  var pending = false;

  function applyBadges() {
    pending = false;
    document.querySelectorAll('[data-product-id]').forEach(function (card) {
      var isPolarized = polarizedMap[card.getAttribute('data-product-id')] === true;
      var existing = card.querySelector('.is-polarized');

      if (isPolarized && !existing) {
        var imageWrap = card.querySelector('.card-image');
        if (imageWrap) {
          var badge = document.createElement('span');
          badge.className = 'is-polarized';
          badge.textContent = 'Polarized';
          imageWrap.insertBefore(badge, imageWrap.firstChild);
        }
      } else if (!isPolarized && existing) {
        existing.remove();
      }
    });
  }

  function scheduleApply() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(applyBadges);
  }

  scheduleApply();
  new MutationObserver(scheduleApply).observe(document.body, { childList: true, subtree: true });
})();
